export const hideListSmall = 'hidden @2xl/list:inline';
export const hideListMedium = 'hidden @4xl/list:inline';
